"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccessToken = void 0;
const react_query_1 = require("react-query");
const useCirrus_1 = require("./useCirrus");
function useAccessToken(locationId) {
    const { socket } = useCirrus_1.useCirrus();
    return react_query_1.useQuery(['access-token', socket.id, socket.url, locationId], () => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const response = yield socket.request({
            messageType: 'CirrusLocalRequest',
            localMessageType: 'configAPI',
            list: [{ resourceType: 'BlobDTO', blobType: 'getAccessToken', blobData: btoa(locationId) }],
        });
        const blobData = (_b = (_a = response.list) === null || _a === void 0 ? void 0 : _a[0].blobData) !== null && _b !== void 0 ? _b : '';
        return atob(blobData);
    }), { cacheTime: 60 * 1000, staleTime: 60 * 1000 });
}
exports.useAccessToken = useAccessToken;
//# sourceMappingURL=useAccessToken.js.map